/*
 * Module for controlling topic searches, including searches by Response, Mapping, Status, and Cat code
 */

define([
  "marionette",
  "backbone",
  "jquery",
  "underscore",
  "messaging/messenger",
  "backbone.syphon",
  "modules/contentsSplit/contents/contentsSearch/contentsSearchView",
  "modules/contentsSplit/contents/contentsSearch/contentsSearchModel",
], function (Marionette, Backbone, $, _, Messenger, BackboneSyphon, ContentsSearchView) {
  "use strict";

  return Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "topicSearch";
      this.region = options.region;
    },
    show: function () {
      //model used to keep track of the search mode and store search options
      this.model = new Backbone.Model({
        mode: 1,
      });
      this.model.selectedLocale = 0;
      this.view = new ContentsSearchView.contentsSearchView({ model: this.model });
      const kbId = Messenger.reqres.request("active:kb");
      this._getLocales(kbId);
      this.view.on(
        "click:search",
        function (args) {
          const data = BackboneSyphon.serialize(args.view);
          let rawSearchValue;
          let encodedSearchValue;
          if (data.searchField) {
            rawSearchValue = data.searchField.trim();
            encodedSearchValue = rawSearchValue.escapeHtml();
          } else {
            rawSearchValue = "";
            encodedSearchValue = "";
          }
          //search must not be empty or we must be searching in a mode other than 'by name' and 'by url'
          if (
            encodedSearchValue.length > 0 ||
            (this.view.searchMode() !== this.view.SEARCH_BY_NAME &&
              this.view.searchMode() !== this.view.SEARCH_BY_URL_STRING)
          ) {
            //save before search
            Messenger.save(function (success) {
              if (success) {
                let searchObj;
                //perform a different search depending on the search mode we are in
                if (this.view.searchMode() === this.view.SEARCH_BY_NAME) {
                  searchObj = Messenger.reqres.request(
                    "search:content:by:mapping:name",
                    rawSearchValue,
                  );
                } else if (this.view.searchMode() === this.view.SEARCH_BY_URL_STRING) {
                  searchObj = Messenger.reqres.request(
                    "search:content:by:url:string",
                    rawSearchValue,
                  );
                } else if (this.view.searchMode() === this.view.SEARCH_BY_MISSING) {
                  searchObj = Messenger.reqres.request(
                    "search:content:missing",
                    this.model.selectedLocale,
                  );
                } else if (this.view.searchMode() === this.view.SEARCH_BY_MODIFIED) {
                  searchObj = Messenger.reqres.request(
                    "search:content:modified",
                    this.model.selectedLocale,
                  );
                } else if (this.view.searchMode() === this.view.SEARCH_BY_IGNORED) {
                  searchObj = Messenger.reqres.request("search:content:ignored");
                } else if (this.view.searchMode() === this.view.SEARCH_BY_NEW) {
                  searchObj = Messenger.reqres.request("search:content:new");
                }
                //send the results to be shown in the topics page
                Messenger.vent.trigger("contents:search:results", searchObj);

                Messenger.vent.trigger("set:content:search:locale", this.model.selectedLocale);
              }
              console.log(data.searchField);
            }, this);
          }
        },
        this,
      );

      // this.showRegion(this.view);
    },
    //used by parent modules to change the search mode programmatically
    changeSearchMode: function (modeNumber) {
      if (this.view) {
        this.view.model.set("mode", modeNumber);
      }
    },
    setSelectedLocale: function (localeId) {
      this.model.selectedLocale = localeId;
      this.view.render();
    },
    //trigger search externally using this function if we want to cause a search to happen without hitting the search
    // button
    triggerSearch: function () {
      if (this.view) {
        this.view.trigger("click:search", { view: this.view }); //pass in the view as an argument
      }
    },
    _getLocales: function (kbId) {
      this.model.languages = Messenger.reqres.request("fetch:kb:languages", kbId);
      this.model.languages.onSynced(function () {
        // Add a dummy "All Locales" model with an ID of zero
        const allLocalesModel = new Backbone.Model({
          name: $.t("contents.search.allLocales"),
          id: 0,
        });
        this.model.languages.add(allLocalesModel, { at: 0 });
        this.showRegion(this.view);
      }, this);
    },
  });
});
